module.exports = __webpack_public_path__ + "img/BoardEmpty.bbb54b11.svg";